import * as enums from "../enums/enums";

export const setInsightsJson = json => {
  return {
    type: enums.SET_INSIGHTS_JSON,
    json
  };
};

export const setCardsJson = json => {
  return {
    type: enums.SET_CARDS_JSON,
    json
  };
};

export const setTagFilter = tag => {
  return {
    type: enums.SET_TAG_FILTER,
    tag
  };
};

export const setTopicFilter = topic => {
  return {
    type: enums.SET_TOPIC_FILTER,
    topic
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions.js